<template>
  <div >

<!--    <div class="text-subtitle1 q-py-sm ">Address</div>-->
    <template v-if="fieldValue !== undefined">
      <q-form
          @submit="onSubmit"
          ref="form"
      >
        <div class="full-width">
          <q-expansion-item
              icon="s_home"
              label="Property Location"
              v-model="ex_location"
          >
          <div class="row ">
            <div class="col-12 col-md-8 q-px-sm q-py-sm ">
              <FieldAddress
                  v-model="fieldValue.address"
                  :field="{layout_injected_label: 'Address', label: 'Address', required: true, requiredText: null, options: {}}"
                  @onAddressSelected="onAddressSelected"
                  :doNotCheckStateLicense="true"
                  :hide_bottom_space="true"
              ></FieldAddress>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldText
                  v-model="fieldValue.unit"
                  :field="{layout_injected_label: 'Unit', label: 'Unit', required: false, requiredText: null, options: {}}"
                  :hide_bottom_space="true"
              ></FieldText>
            </div>
          </div>
          <div class="row ">
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldText
                  v-model="fieldValue.city"
                  :field="{layout_injected_label: 'City', label: 'City', required: true, requiredText: null, options: {}}"
                  :hide_bottom_space="true"
              ></FieldText>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldState
                  v-model="fieldValue.state"
                  :field="{layout_injected_label: 'State', label: 'State', required: true, requiredText: null, options: {}}"
                  :hide_bottom_space="true"
              ></FieldState>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldZipcode
                  v-model="fieldValue.zip"
                  :field="{layout_injected_label: 'Zip', label: 'Zip', required: true, requiredText: null, options: {}}"
                  :hide_bottom_space="true"
              ></FieldZipcode>
            </div>
          </div>
          <div class="row  ">
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldSelect
                  v-model="fieldValue.property_type"
                  :field="{layout_injected_label: 'Type Of Property', label: 'Type Of Property', required: true, requiredText: null,
                options: {
                  'single_family': 'Single Family',
                  'condo': 'Condominium',
                  'townhouse': 'Townhouse',
                  'coop': 'Co-operative',
                  '2 to 4 Unit': '4 Years',
                  'multi_family_more': 'Multi-Family (5+ units)',
                  'manufactured': 'Manufactured Home',
                  'commercial': 'Commercial',
                  'farm': 'Farm',
                  'home_and_business_combined': 'Home & Business',
                  'Land': 'Land'
                }
                }"
                  :hide_bottom_space="true"
              ></FieldSelect>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldSelect
                  v-model="fieldValue.status"
                  :field="{layout_injected_label: 'Status', label: 'Status', required: false, requiredText: null,
                 options: {
                  'sold': 'Sold',
                  'pending_sale': 'Pending Sale',
                  'retained': 'Retained'
                }
                }"
                  :hide_bottom_space="true"
              ></FieldSelect>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldSelect
                  v-model="fieldValue.intended_occupancy"
                  :field="{layout_injected_label: 'Intended Occupancy', label: 'Intended Occupancy', required: false, requiredText: null,
                 options: {
                  'investment': 'Investment',
                  'primary_residence': 'Primary Residence',
                  'second_home': 'Second Home',
                  'other': 'other'
                }
                }"
                  :hide_bottom_space="true"
              ></FieldSelect>
            </div>
          </div>
          </q-expansion-item>
          <q-expansion-item
              icon="s_paid"
              label="Market Value"
              caption="and Income"
          >
          <div class="row  ">
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldMoney
                  v-model="fieldValue.market_value"
                  :field="{layout_injected_label: 'Market value', label: 'Market value', required: false, requiredText: null, options: {}}"
              ></FieldMoney>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm ">
              <FieldMoney
                  v-model="fieldValue.monthly_gross_rent_income"
                  :field="{layout_injected_label: 'Monthly Gross Rent Income', label: 'Monthly Gross Rent Income', required: false, requiredText: null, options: {}}"
              ></FieldMoney>
            </div>
            <div class="col-12 col-md-4 q-px-sm q-py-sm " >
            <FieldMoney
                v-model="fieldValue.monthly_insurance"
                :field="{layout_injected_label: 'Monthly Insurance/Tax Expenses', label: 'Monthly Insurance/Tax Expenses', required: false, requiredText: null, options: {}}"
            ></FieldMoney>
          </div>
<!--            <div class="col-12 col-md-4 q-px-sm q-py-sm " >-->
<!--              <FieldMoney-->
<!--                  v-model="fieldValue.current_mortgage_balance"-->
<!--                  :field="{layout_injected_label: 'Current Mortgage Balance', label: 'Current Mortgage Balance', required: false, requiredText: null, options: {}}"-->
<!--              ></FieldMoney>-->
<!--            </div>-->
          </div>
          <div class="row  ">
<!--            <div class="col-12 col-md-4 q-px-sm q-py-sm ">-->
<!--              <FieldMoney-->
<!--                  v-model="fieldValue.monthly_rent_net_income"-->
<!--                  :field="{layout_injected_label: 'Monthly Rent Net Income', label: 'Monthly Rent Net Income', required: false, requiredText: null, options: {}}"-->
<!--              ></FieldMoney>-->
<!--            </div>-->
<!--            <div class="col-12 col-md-4 q-px-sm q-py-sm ">-->
<!--              <FieldMoney-->
<!--                  v-model="fieldValue.monthly_mortgage_payment"-->
<!--                  :field="{layout_injected_label: 'Monthly Mortgage Payment', label: 'Monthly Mortgage Payment', required: false, requiredText: null, options: {}}"-->
<!--              ></FieldMoney>-->
<!--            </div>-->

          </div>
          </q-expansion-item>
        </div>
      </q-form>
      <q-expansion-item
          icon="s_account_balance_wallet"
          label="Mortgage Loans"
          caption="on this Property"
      >
<!--      <div class="text-subtitle1 q-py-sm ">Mortgage Loans on this Property</div>-->
      <q-list v-if="fieldValue && fieldValue.loans && fieldValue.loans.length > 0" bordered padding class="rounded-borders q-mb-md">
        <template v-for="(place, loan_index) in fieldValue.loans"
                  :key="loan_index">
          <q-item clickable v-ripple   active-class="bg-teal-1 text-grey-8" :active="loan_index === index">
            <q-item-section avatar>
<!--              <q-avatar icon="s_paid" color="grey" text-color="white" />-->
              <q-icon style="color: #ccc;" name="s_credit_card" />
            </q-item-section>

            <q-item-section @click="selectRealEstate(loan_index)">
              <q-item-label ><span class="q-mr-xs" v-if="fieldValue.loans[loan_index].creditor_name">{{fieldValue.loans[loan_index].creditor_name}}</span>
              </q-item-label>
            </q-item-section>

            <q-item-section side @click.stop="confirmDeleteAlert(loan_index)">
              <q-icon name="s_delete" color="amber"  />
            </q-item-section>
          </q-item>
        </template>
      </q-list>
      <div class="row  ">
        <div class="col-12 q-py-sm q-ml-none col-md-12 q-gutter-sm q-gutter-y-md">
          <q-btn

              class="mw-form-v2-btn-submit "
              :flat="!settings.theme.next.cs ? settings.theme.button.flat: null"
              :rounded="!settings.theme.next.cs ? settings.theme.button.rounded: null"
              :round="!settings.theme.next.cs ? settings.theme.button.round: null"

              :outline="true"
              :push="!settings.theme.next.cs ? settings.theme.button.push: null"
              :unelevated="!settings.theme.next.cs ? settings.theme.button.unelevated: true"
              :noCaps="!settings.theme.next.cs ? settings.theme.button.noCaps: null"
              :glossy="!settings.theme.next.cs ? settings.theme.button.glossy : null"
              :size="settings.theme.next.cs ? settings.theme.next.size : settings.theme.button.size"

              label="Add Loan" type="button" color="primary"
              :class="{'mw-form-v2-btn-next-cs':  settings.theme.next.cs}"
              @click="AddItem()"
          >
          </q-btn>
        </div>
      </div>
      </q-expansion-item>
    </template>

    <q-dialog v-model="editModalVisible" persistent>
      <q-card>
        <q-card-section class="">
          <ModuleBorrowerRealEstateOwnLoan ref="module" v-model="fieldValue.loans[index]"></ModuleBorrowerRealEstateOwnLoan>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Remove this loan" @click="confirmDelete = true" color="primary"  />
          <q-btn flat label="Confirm" @click="Confirm()" color="primary"/>
        </q-card-actions>
      </q-card>
    </q-dialog>


    <q-dialog v-model="confirmDelete" persistent>
      <q-card>
        <q-card-section class="row   items-center">
          <q-avatar icon="s_place" color="primary" text-color="white" />
          <span class="q-ml-sm">Are you sure to delete this loan {{fieldValue.loans[confirmDeleteIndex] && fieldValue.loans[confirmDeleteIndex].creditor_name}}?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn flat label="Delete" @click="deleteItem()" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>

  </div>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import FieldAddress from "@/components/fields/FieldAddress";
import FieldText from "@/components/fields/FieldText";
import FieldState from "@/components/fields/FieldState";
import FieldZipcode from "@/components/fields/FieldZipcode";
import FieldSelect from "@/components/fields/FieldSelect";

import FieldMoney from "@/components/fields/FieldMoney";
import ModuleBorrowerRealEstateOwnLoan from "@/components/modules/ModuleBorrowerRealEstateOwnLoan";

import {mapActions} from "vuex";
export default {
  components: {
    FieldAddress,
    FieldText,
    FieldState,
    FieldZipcode,
    FieldSelect,
    FieldMoney,
    ModuleBorrowerRealEstateOwnLoan
  },
  props: {
    modelValue: {},
    field:{}
  },
  data() {
    return {
      ex_location: true,
      index: null,
      editModalVisible: false,
      confirmDelete: false,
      confirmDeleteIndex: null,
      loans_item: {
        address: "",
        unit: "",
        city: "",
        state: "",
        zip: "",
        country: "",
        property_type: "",
        status: "",
        intended_occupancy: "",
        market_value: "",
        monthly_gross_rent_income: "",
        current_mortgage_balance: "",
        monthly_rent_net_income: "",
        monthly_mortgage_payment: "",
        monthly_insurance: "",
        loans: [],
      },
      loan: {
        creditor_name: "",
        account_number: "",
        monthly_mortgage_payment: "",
        credit_limit: "",
        unpaid_balance: "",
        to_be_paid_off: false,
        type: ""
      },
      loan_types: {}
    };
  },
  emits: ['update:modelValue'],
  methods: {
    ...mapActions({
      nextScreen: 'values/list/nextScreen'
    }),
    Confirm() {
      this.$refs.module.validate().then(success => {
        if (success) {
          this.editModalVisible = false;
        }
      });
    },
    confirmDeleteAlert(index) {

      this.confirmDeleteIndex = index;
      this.confirmDelete = true;

    },
    selectRealEstate(place_index) {
      //this.$refs.form.resetValidation();
      this.confirmIndex = place_index;
      this.confirmDeleteIndex = place_index;
      this.confirmIndexToClear = this.index;
      this.index = place_index;
      this.editModalVisible = true;
    },
    deleteItem() {
      this.editModalVisible = false;
      this.fieldValue.loans.splice(this.confirmDeleteIndex, 1);
      this.index = null;
    },
    AddItem() {
      if(this.fieldValue.loans === undefined) {
        this.fieldValue.loans = [];
      }
      this.index = this.fieldValue.loans.push(Object.assign({id: this.generateId()}, this.loan)) - 1;
      this.confirmDeleteIndex = this.index;
      this.confirmIndex = this.index;
      this.editModalVisible = true;
    },
    onSubmit() {

    },
    generateId() {
      return new Date().getTime() + '_' + Math.random();
    },
    validate() {
      return this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    onAddressSelected(loans_item) {
      this.fieldValue.city = loans_item.city;
      this.fieldValue.state = loans_item.state;
      this.fieldValue.zip = loans_item.zipcode;
    },
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form'
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please select';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
<style>
.field_no_bottom_line .q-field__control:before {
  border-bottom-color: transparent !IMPORTANT;
}
.field_no_bottom_line  .q-field__control:after {
  background: none !important;
}
.field_no_bottom_line .q-field__control {
  display: none;
}
.pac-container {
  z-index: 1000000;
}
</style>
